module.exports = __webpack_public_path__ + "static/media/appt-block-hour.6ddf7542.svg";